import styled from 'styled-components'

export const FadeBackground = styled.div`
  color: rgb(255, 255, 255);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 10px;
  width: auto;
`
